import type { ExpressOnboardingGeneratorsTableSiteTodoStatus } from "../../ExpressOnboarding.types";

/**
 * Whether the configuration todo of a site exists and is not done yet.
 * Sites with an open configuration todo are locked in the express onboarding table.
 */
function getIsConfigurationTodoOpen(
  siteTodosStatus?: ExpressOnboardingGeneratorsTableSiteTodoStatus
) {
  return (
    !!siteTodosStatus?.configuration_todo_id &&
    !siteTodosStatus.configuration_todo_done
  );
}

export { getIsConfigurationTodoOpen };
